export const GET_GLOBAL_PARAMETERS = "GET_GLOBAL_PARAMETERS";
export const GET_GLOBAL_PARAMETERS_ERROR = "GET_GLOBAL_PARAMETERS_ERROR";
